import { render, staticRenderFns } from "./ExamModal.vue?vue&type=template&id=643f4fe5"
import script from "./ExamModal.vue?vue&type=script&lang=js"
export * from "./ExamModal.vue?vue&type=script&lang=js"
import style0 from "./ExamModal.vue?vue&type=style&index=0&id=643f4fe5&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports